import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { AppService } from './services/app.service';
import { environment } from '@environments/environment';


export const AuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
):
Observable<boolean | UrlTree> 
| Promise<boolean | UrlTree> 
| boolean 
| UrlTree => {

  const token = inject(CookieService).get('access_token');
  const app_service = inject(AppService);

  if (!token) {
    window.location.href = environment.access + '/login';
    return false;
  }
  app_service.loading = false; 
  return true;
}
